import { CUSTOMER_APIS } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";
import { IVaccinationSummaryResponse } from "@/api_framework/api_modals/Vaccination";
import { setVaccinationSummaryData } from "@/app_redux/reducers/slices/auth/customer_profile_slice";

AxiosCurlirize(axios, () => {});

export const useVaccinationSummaryListAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (petId: string, userId: string,source?:string) => {
      try {
        dispatch(
          setLoading({
            key: "isvaccinationTableLoading",
            status: true,
          }),
        );


          let URL=`${CUSTOMER_APIS?.VACCINATION_SUMMARY_LIST?.baseURL}${petId}/${userId}/`
        if (source === "deworming") {
          URL = `${CUSTOMER_APIS?.VACCINATION_SUMMARY_LIST?.baseURL}${petId}/${userId}/?vaccine_type=deworming`;
        }
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios
          .get(URL, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IVaccinationSummaryResponse>) => {
            if (res.data.status === true) {
              dispatch(setVaccinationSummaryData(res.data.data));
              dispatch(
                setLoading({
                  key: "isvaccinationTableLoading",
                  status: false,
                }),
              );
              return { status: true, message: res.data.message };
            } else {
              dispatch(setVaccinationSummaryData(null));
              dispatch(
                setLoading({
                  key: "isvaccinationTableLoading",
                  status: false,
                }),
              );
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            dispatch(setVaccinationSummaryData(null));
            sendCurl(e.config["curlCommand"]);
            // captureError(e);
            dispatch(
              setLoading({
                key: "isvaccinationTableLoading",
                status: false,
              }),
            );
            const message = e.response.data as any;
            return { status: false, message: message.message };
          });
        return response;
      } catch (e: any) {
        dispatch(
          setLoading({
            key: "isvaccinationTableLoading",
            status: false,
          }),
        );
        dispatch(setVaccinationSummaryData(null));
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
